import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { MessageService } from '../../_services/message.service';

import { Easel } from '../../_models/easel';
import { Globals } from '../../_globals/globals';
import { EaselType } from '../../_models/easel_type';
import { EaselFamily } from '../../_models/easel_family';
import { Product } from '../../_models/product';


@Injectable({
  providedIn: 'root'
})

export class EaselService {

  constructor(
    private http: HttpClient,
    // private httpParams: HttpParams,
    private globals: Globals,
    private messageService: MessageService
  ) {}


  getEasels(searchParams): Observable<Easel[]> {

    console.log('-->--> Ejecutando servicio getEasels.');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    return this.http.get<Easel[]>(this.globals.apiUrl + '/easels', options)
      .pipe(
        tap( data => console.log(' -> Proyectos obtenidos desde getEasels: ')), // + JSON.stringify(data))),
        catchError(this.handleError<Easel[]>('getEasels', [])
      ));
  }

  getAllEasels(): Observable<Easel[]> {

    console.log('-->--> Ejecutando servicio getAllEasels');

    return this.http.get<Easel[]>(this.globals.apiUrl + '/easels')
      .pipe(
        tap( data => console.log(' -> Proyectos obtenidos desde getAllEasels: ' + JSON.stringify(data))),
        catchError(this.handleError<Easel[]>('getAllEasels', [])
      ));
  }

  getEasel(searchParams): Observable<Easel> {

    console.log('-->--> Ejecutando servicio getEasel');
    console.log(searchParams);
    console.log('---------------');

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: new HttpParams()
        .set('id', searchParams.id)
    };
    return this.http.get<Easel>(this.globals.apiUrl + '/easel', options)
      .pipe(
        tap(  _ => this.log('get easel')),
        catchError(this.handleError<Easel>('getEasel', null)
      ));
  }

  updateEasel(easelIn: Easel): Observable<Easel> {

    console.log('-->--> Ejecutando servicio updateEasel');
    console.log(easelIn);
    console.log('---------------');

    let options = {};
    if (easelIn.id === null) {
      options = { params: new HttpParams()
        .set('id', '0') };
    } else {
      options = { params: new HttpParams()
        .set('id', easelIn.id.toString()) };
    }

    return this.http.put<Easel>(this.globals.apiUrl + '/easel', easelIn, options)
      .pipe(
        tap(  _ => this.log('updated easel')),
        catchError(this.handleError<Easel>('updateEasel', null)
      ));
  }

  createEasel(easelIn: Easel): Observable<Easel> {

    console.log('-->--> Ejecutando servicio createEasel');
    console.log(easelIn);
    console.log('---------------');

    let options = {};

    return this.http.post<Easel>(this.globals.apiUrl + '/easel', easelIn, options)
      .pipe(
        tap(  _ => this.log('created easel')),
        catchError(this.handleError<Easel>('createEasel', null)
      ));
  } // End function createEasel

  deleteEasel(easelIn: Easel): Observable<bigint> {

    console.log('-->--> Ejecutando servicio deleteEasel');
    console.log(easelIn);
    console.log('---------------');

    let options = { params: new HttpParams()
        .set('id', easelIn.id.toString()) };

    return this.http.delete<bigint>(this.globals.apiUrl + '/easel', options)
      .pipe(
        tap(  _ => this.log('deleted easel')),
        catchError(this.handleError<bigint>('deleteEasel', null)
      ));
  } // End function deleteEasel

  // Easels types
  getTypes(): Observable<EaselType[]> {

    console.log('-->--> Ejecutando servicio getTypes');

    return this.http.get<EaselType[]>(this.globals.apiUrl + '/easelTypes')
      .pipe(
        tap( data => console.log(' -> Nº de tipos obtenidos desde getTypes: ' + data.length)),
        catchError(this.handleError<EaselType[]>('getTypes', [])
        ));
  } // End function getTypes

  // Easels families
  getFamilies(): Observable<EaselFamily[]> {

    console.log('-->--> Ejecutando servicio getFamilies');

    return this.http.get<EaselFamily[]>(this.globals.apiUrl + '/easelFamilies')
      .pipe(
        tap( data => console.log(' -> Nº de familias obtenidas desde getFamilies: ' + data.length)),
        catchError(this.handleError<EaselFamily[]>('getFamilies', [])
        ));
  } // End function getFamilies

  //  Freights
  getFreights(searchParams): Observable<Product[]> {

    console.log('-->--> Ejecutando servicio getFreights');
    console.log(searchParams);
    console.log('---------------');

    const options = { params: new HttpParams()
        .set('f_genre', searchParams)
    };

    console.log('options: ' + JSON.stringify(options));

    return this.http.get<Product[]>(this.globals.apiUrl + '/easelFreight', options)
      .pipe(
        tap( data => console.log(' -> Nº de fletes obtenidos desde getFreights: ' + data.length)),
        catchError(this.handleError<Product[]>('getFreights', [])
        ));
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`HeroService: ${message}`);
  }

  // -------------------------

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error (error); // lot to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // TODO: Let the app keep running by returning an empty result.
      return of (result as T);
    };
  }

}
